import { FleetUser } from "../models/FleetUser";

export class CreateFleetUserResponse {
    fleetUser?: FleetUser;
}